import './TextImage.scss';

import { ReactNode } from 'react';

interface TextImageProps {
  desktopLayout?: 'text-image' | 'image-text';
  mobileLayout?: 'text-image' | 'image-text';
  imagePosition?: 'center' | 'bottom';
  desktopImageSrc?: string;
  mobileImageSrc?: string;
  desktopBackgroundImageSrc?: string;
  mobileBackgroundImageSrc?: string;
  theme?: 'dark' | 'light';
  alt?: string;
  children?: ReactNode;
  buttons?: ReactNode;
  footer?: ReactNode;
}

const TextImage = ({
  desktopLayout = 'text-image',
  mobileLayout = 'text-image',
  imagePosition = 'center',
  desktopImageSrc,
  mobileImageSrc,
  desktopBackgroundImageSrc,
  mobileBackgroundImageSrc,
  theme = 'dark',
  alt = '',
  children,
  buttons,
  footer,
}: TextImageProps) => {
  return (
    <div className={`text-image image-${imagePosition}`}>
      <div className='container'>
        <div className={`row text-image__row desktop-${desktopLayout} mobile-${mobileLayout}`}>
          <div className='col-12 col-lg-5 align-self-center'>
            <div className={`text-image__content ${theme}`}>
              {children}

              {buttons && <div className='text-image__buttons'>{buttons}</div>}

              {footer}
            </div>
          </div>

          <div className='col-1 d-none d-lg-block'></div>

          <div className='col-12 col-lg-6 image-column'>
            {desktopImageSrc && (
              <div className={`text-image__desktop-image ${mobileImageSrc ? 'has-mobile' : ''}`}>
                <img src={desktopImageSrc} alt={alt} />
              </div>
            )}

            {mobileImageSrc && (
              <div className='text-image__mobile-image'>
                <img src={mobileImageSrc} alt={alt} />
              </div>
            )}
          </div>
        </div>

        {(desktopBackgroundImageSrc || mobileBackgroundImageSrc) && (
          <div className='text-image__bg-image'>
            {desktopBackgroundImageSrc && (
              <img src={desktopBackgroundImageSrc} className='desktop' alt='Decorative background image' />
            )}

            {mobileBackgroundImageSrc && (
              <img src={mobileBackgroundImageSrc} className='mobile' alt='Decorative background image' />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default TextImage;
